export const samplePlaygroundEmail = {
  subject: `Welcome to the playground`,
  body: `## Wait, what is this?

This is an online playground for experimenting with Buttondown's editor. It works just like the real thing, making it perfect to create examples for documentation, marketing, or support!

---

Headings are written like this:

\`\`\`text
# Heading
## Subheading
### Subsubheading
\`\`\`


# Heading

## Subheading

### Subsubheading
`,
};
